module.exports = {
    draft: 'draft', // just a draft
    active: 'active', // campaign is about to be processing or processing now
    stopped: 'stopped', // campaign finished
};
